import { noop } from 'rxjs';
import { NULL_SERVICE, Service } from '../base/service';

export interface TextEditService extends Service {
  insertText(text: string): void;
  deleteSelection(): void;
}

export const NULL_TEXT_EDIT_SERVICE: TextEditService = {
  ...NULL_SERVICE,
  insertText: noop,
  deleteSelection: noop,
};
